import { useModalContext } from "components/modal";
import { Button } from "components/button";

interface ConfirmActionModalProps {
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  variant?: "danger" | "primary";
  onConfirm: () => void;
}

export default function ConfirmActionModal({
  title,
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  variant = "primary",
  onConfirm,
}: ConfirmActionModalProps) {
  const { setModal } = useModalContext();

  const dangerStyle = { margin: 0, background: "red", color: "white" };
  const primaryStyle = { margin: 0 };

  return (
    <div className="p-2">
      <h3 className="text-lg font-semibold text-gray-800 mb-2">{title}</h3>
      <p className="text-sm text-gray-600 mb-6">{message}</p>
      <div className="flex justify-end gap-3">
        <Button style={{ margin: 0 }} onClick={() => setModal(undefined)}>
          {cancelLabel}
        </Button>
        <Button
          primary={variant === "primary"}
          style={variant === "danger" ? dangerStyle : primaryStyle}
          onClick={() => {
            onConfirm();
            setModal(undefined);
          }}
        >
          {confirmLabel}
        </Button>
      </div>
    </div>
  );
}
